export default "__VITE_ASSET__f85afe42__"